import { createTestId } from 'utils';
import React, { useContext, useEffect, useState, useLayoutEffect } from 'react'
import { NavLink, useLocation, useParams } from "react-router-dom";
import * as Icon from "react-feather"
import PerfectScrollbar from 'react-perfect-scrollbar'
import Logo from "assets/img/logo.png"
import { subscribe, publish } from 'utils/global-events';
import { OnlyIconButton } from 'components/button';
import classNames from 'classnames';
import * as MenuIcon from "components/icon"
import { AppContext } from 'configuration/app-context';
import { ThemeContext } from 'configuration/theme-context';
import { useSelector } from 'react-redux';
import { constants } from 'utils/webclient';

const Sidebar = () => {

    const { translate } = useContext(AppContext)
    const { theme, toggleTheme } = useContext(ThemeContext)
    const location = useLocation()
    const member = useSelector(state => state.member)
    const patient = useSelector(state => state.patient)
    const patientHas = useSelector(state => state.patientHas)

    const telemedicineRoutes = ["vaccines"]
    const telemedicineOpen = Boolean(telemedicineRoutes.filter(x => location.pathname.includes(x)).length > 0)

    const navigation = [
        {
            route: "/",
            label: "menu_home",
            icon: MenuIcon.Home,
            theme: "theme-khc"
        },
        {
            route: patient?.isLoyaltyMember ? "/membership" : "/koc-health-club",
            label: "menu_koc_health_club",
            icon: MenuIcon.Membership,
            theme: "theme-khc",
            show: patient?.loyaltyUsabilityStatus,
            hasSubMenu: !patient?.isLoyaltyMember,
            subPaths: [
                "/membership/benefits", 
                "/membership/points", 
                "/membership/invite-earn", 
                "/membership/point-history", 
                "/membership/increase-points",
                "/membership/point-transfer",
                "/membership/settings",
                "/membership/catalog",
                "/membership/faq"
            ],
            subRoutes: [
                {
                    label: "sidebar_menu_what_is_health_club",
                    route: "/koc-health-club",
                },
                {
                    label: "sidebar_menu_benefits",
                    route: "/koc-health-club/benefits",
                },
            ]
        },
        {
            route: "/packages",
            label: "menu_packages",
            icon: MenuIcon.Packages,
            subPaths: ["/package-plans", "/compare-plans"],
            hideOnChild: true,
            theme: "theme-khc"
        },
        {
            route: "/privileges",
            label: "menu_privileges",
            icon: MenuIcon.Privilege,
            theme: "theme-khc",
            show: patientHas?.showPrivilege ? patientHas?.showPrivilege : false
        },
        {
            route: "/appointments",
            label: "menu_appointment",
            icon: MenuIcon.Appointment,
            subPaths: ["/appointment"],
            theme: "theme-khc"
        },
        {
            route: "/visits",
            label: "menu_visits",
            icon: MenuIcon.Visit,
            theme: "theme-khc"
        },
        {
            route: "/reports",
            label: "menu_reports",
            icon: MenuIcon.Report,
            subPaths: ["/reports-detail"],
            theme: "theme-khc"
        },
        {
            route: "/vaccines",
            label: "menu_vaccine",
            icon: MenuIcon.Vaccine,
            theme: "theme-khc"
        },
        {
            route: "/prescriptions",
            label: "menu_prescriptions",
            icon: MenuIcon.Prescription,
            theme: "theme-khc"
        },
        {
            route: "/medicines",
            label: "menu_medicine",
            icon: MenuIcon.Medicine,
            theme: "theme-khc"
        },
        // {
        //     route: "/survey",
        //     label: "menu_survey",
        //     icon: MenuIcon.Survey
        // },
        {
            route: "/health-form",
            label: "menu_health_form",
            icon: MenuIcon.InfoForm,
            theme: "theme-khc"
        },
        {
            route: "/files",
            label: "menu_files",
            icon: MenuIcon.File,
            theme: "theme-khc"
        },
        {
            route: "/children",
            label: "menu_children",
            icon: MenuIcon.Child,
            hideOnChild: true,
            theme: "theme-khc"
        },
        {
            route: "/chat",
            label: "menu_messages",
            icon: MenuIcon.Message,
            theme: "theme-khc"
        },
        {
            route: "/video-portal",
            label: "menu_video_portal",
            icon: MenuIcon.Video,
            theme: "theme-khc"
        },
        {
            route: "/hospitals",
            label: "menu_hospitals",
            icon: MenuIcon.Hospital,
            theme: "theme-khc"
        },
        {
            route: "/departments",
            label: "menu_departments",
            icon: MenuIcon.Department,
            theme: "theme-khc"
        },
        {
            route: "/doctors",
            label: "menu_doctors",
            icon: MenuIcon.Doctor,
            theme: "theme-khc"
        },
        {
            route: "/pharmacy",
            label: "menu_pharmacies",
            icon: MenuIcon.Pharmacy,
            theme: "theme-khc"
        },
        {
            route: "/insurance-companies",
            label: "menu_insurance_companies",
            icon: MenuIcon.InsuranceCompany,
            theme: "theme-khc"
        },
        {
            route: "/code-lotus",
            label: "menu_home",
            icon: MenuIcon.Home,
            theme: "theme-codeLotus"
        },
        {
            route: "/videos",
            label: "menu_code_lotus_videos",
            icon: MenuIcon.Video,
            theme: "theme-codeLotus"
        },
        {
            route: "/podcasts",
            label: "menu_code_lotus_podcasts",
            icon: MenuIcon.Podcast,
            theme: "theme-codeLotus"
        },
        {
            route: "/blog",
            label: "menu_code_lotus_blog",
            icon: MenuIcon.Blog,
            theme: "theme-codeLotus"
        }
    ]

    const [openSidebar, setOpenSidebar] = useState(false)
    const [openMenu, setOpenMenu] = useState(telemedicineOpen)

    let activeTheme = constants.theme.find((item) => item.name == theme)

    useEffect(() => {
        subscribe("onOpenSidebar", () => {
            setOpenSidebar( openSidebar => !openSidebar)
        })
    }, [])

    useLayoutEffect (() => {
        if(openSidebar){
            document.body.classList.add("overflow-hidden")
        }
        return () => document.body.classList.remove("overflow-hidden")
    },[openSidebar])

    return (
        <div>
            <div className={classNames("sidebar", {"opened": openSidebar})}>
                <div className="sidebar-header">
                    <NavLink data-testid={createTestId('NavLink', 'Sidebar', 'logo')} to="/" className="logo">
                        <img src={activeTheme?.logo} alt={activeTheme?.title} />
                    </NavLink>
                    <OnlyIconButton
                        className=""
                        data-testid={createTestId('onlyiconbutton', 'Sidebar', 1)} onClick={() => {
                            publish("onOpenSidebar")
                        }}>
                        <Icon.X />
                    </OnlyIconButton>
                </div>
                <PerfectScrollbar>
                    <ul className="sidebar-menu">
                        {
                            constants.theme.filter(item => item.name != theme).map((item, index) => {
                                return(
                                    <li
                                        className="menu-item cursor-pointer"
                                        data-testid={createTestId('li', 'Sidebar', 2)} onClick={() => toggleTheme(item?.name)} key={index}>
                                        <span className="menu-link">
                                            <img src={item?.badge} className='w-6 h-6' alt=""/>
                                            <span>{item?.title}</span>
                                        </span>
                                    </li>
                                )
                            })
                        }

                        {
                        navigation.filter(item => item.theme == theme).map((nav, index) => {

                            if ((nav?.hideOnChild && member.patientId != member.profileId) || nav?.show == false) return null
                            const CIcon = nav.icon;

                            const isSubPath = nav?.subPaths?.filter(x => x == location.pathname).length > 0

                            if (nav.hasSubMenu) {

                                const subMenuOpen = nav.subRoutes.filter(x => x.route == location.pathname).length > 0
                                const isOpen = subMenuOpen ? true : openMenu
                                return (
                                <li
                                    key={nav.route}
                                    className={`menu-item has-submenu cursor-pointer active ${isOpen && 'open'}`}
                                    data-testid={createTestId('li', 'Sidebar', 3)} onClick={() => setOpenMenu(!isOpen)}
                                >

                                    <span className={`menu-link ${isOpen && 'active'}`}>
                                        <CIcon color={(nav.route == location.pathname || isOpen) ? "#fff" : theme == "theme-codeLotus" ? "#81888A" : "#0F1F77"} />
                                        <span className="menu-title">{translate(nav.label)}</span>
                                    </span>
                                    {
                                    nav.subRoutes.length > 0 && (
                                    <ul className="submenu">
                                        {
                                        nav.subRoutes.map((sub, yindex) => {
                                            const SubIcon = sub?.icon;
                                            return (
                                            <li key={sub.route}>
                                                <NavLink data-testid={createTestId('NavLink', 'Layout', sub.label)} to={sub.route} className={({ isActive }) => (isActive || isSubPath ? 'active' : '')} end>
                                                    {
                                                        SubIcon && <SubIcon color={sub.route == location.pathname || isSubPath ? "#fff" : "#0F1F77"} />
                                                    }
                                                    <span className="menu-title">{translate(sub.label)}</span>
                                                </NavLink>
                                            </li>
                                            )
                                        })
                                        }
                                    </ul>
                                    )
                                    }
                                </li>
                                )
                            } else {
                                return (
                                <li key={nav.label} className="menu-item active">
                                    <NavLink data-testid={createTestId('NavLink', 'Layout', nav.label)} to={nav.route} className={({ isActive }) => 'menu-link ' + (isActive || isSubPath ? 'active' : '')}>
                                        <CIcon color={nav.route == location.pathname || isSubPath ? "#fff" : theme == "theme-codeLotus" ? "#81888A" : "#0F1F77"} />
                                        <span className="menu-title">{translate(nav.label)}</span>
                                    </NavLink>
                                </li>
                                )
                            }
                        })
                        }
                    </ul>
                </PerfectScrollbar>
            </div>

            {
                openSidebar &&  (
                    <div
                        className="overlay"
                        data-testid={createTestId('div', 'Sidebar', 4)} onClick={() => {
                            publish("onOpenSidebar")
                        }}></div>
                )
            }

        </div>

    )
}

export default Sidebar